import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ShowActiveCall,
  ReturningCallback,
  returnListCallQueue,
  RequestActiveCall,
  RequestActiveCallSocketVoz,
  InterationNotifier,
  ShowInfoDisplay,
  InitialInteractionMail,
} from "../actions";
import MicroModal from "micromodal";
// import INSTAGRAM from "../build/images/instagram_icon_new.svg";
// import FACEBOOKICON from "../build/images/facebook_icon_new.svg";
// import WHATSAPPICON from "../build/images/whatsapp_icon_new.svg";
// import { ReactComponent as SMSICON} from "../build/images/sms-new.svg";
import { ReactComponent as CLOSEICON } from "../build/images/icons/new-close-icon.svg";
import { ReactComponent as INFOCIRCLE } from "../build/images/icons/info-circle.svg";
import SelectRouteActiveCall from "../components/SelectRouteActiveCall";
import CardInformation from "../components/CardInformation";

const { connection_platform } = require("../services/api");

MicroModal.init();

function validarEmail(email) {
  const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;

  if (!email || typeof email !== "string") {
    return false;
  }
  return EMAIL_REGEX.test(email);
}

const mapStateToProps = (state) => {
  return {
    PermissionRouter: state.routergroups,
    OutBandService: state.outservices,
    InfoUsers: state.informationusers,
    ShowActiveCall: state.showactivecall,
    Messages: state.messages,
    StatusAgent: state.status,
    listCallQueue: state.listcallqueue,
    AtdSimult: state.atdsimult,
    IPCurrent: state.ipcurrent,
    ContactId: state.atendimento,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowActiveCallIn: (post) => {
    dispatch(ShowActiveCall(post));
  },
  ReturningCallbackIn: (
    queueid,
    inforetorno,
    recvcount,
    cdrid,
    mediaid,
    srvin,
    caller,
    called,
    cbackcount,
    status,
  ) => {
    //olhar aqui
    ReturningCallback(
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
    )(dispatch);
    if (status != "2") {
      dispatch(
        returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1), "você"),
      );
    }
  },
  RequestActiveCall: (
    outband,
    infouser,
    trunk,
    mediaid,
    calledDigitado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    cbackcount,
    idgrupo_transb,
    cdrid,
    rawNumber,
  ) => {
    dispatch(
      RequestActiveCall(
        outband,
        infouser,
        trunk,
        mediaid,
        calledDigitado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        cbackcount,
        idgrupo_transb,
        cdrid,
        undefined,
        undefined,
        rawNumber,
      ),
    );
  },
  RequestActiveCallSocketVoz: (
    outband,
    infouser,
    trunk,
    mediaid,
    chamado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    callback_count,
    tech,
    idgrupo_rota,
    idgrupo_transb,
    ipcurrent,
    cdrid,
    rotaencontrada,
  ) => {
    dispatch(
      RequestActiveCallSocketVoz(
        outband,
        infouser,
        trunk,
        mediaid,
        chamado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        callback_count,
        tech,
        idgrupo_rota,
        idgrupo_transb,
        ipcurrent,
        cdrid,
        rotaencontrada,
      ),
    );
  },
  InterationNotifier: (text, type) => {
    dispatch(InterationNotifier(text, type));
  },
  InitialInteractionMail: (email) => {
    dispatch(InitialInteractionMail(email));
  },
  ShowInfoDisplay: (post) => {
    dispatch(ShowInfoDisplay(post));
  },
});

class Activecall extends Component {
  constructor(props) {
    super(props);
    this.state = { senhaincorreta: "none", chamado: "", numeroDoCliente: "" };
  }

  DisplayActiveIn() {
    MicroModal.show("modal__falar-com-cliente");
    this.props.ShowActiveCallIn("disable");
  }

  // SolicitarChamadaAtiva(e, permrouter, mediaid, outband, infouser, status, queue, AtdSimult,ipcurrent, statusAgent){

  //     if(statusAgent.allowCall === false){
  //         this.props.InterationNotifier('Pausa não permite ativo','permission');
  //         return true;
  //     }

  //         if(document.getElementById("chat-message"))
  //         document.getElementById("chat-message").innerText = '';
  //     if((permrouter!="undefined")&&(permrouter!="")) {
  //             var existeRota = false;
  //             var rotaencontrada = false;
  //             var checkRota = false;
  //             var rotaDefault = false;
  //             var rotaAlternativa = false;
  //             var trunk = "";
  //             var addtech = "";
  //             var scriptrunk = "";
  //             var operator = "";
  //             var trunkDef = "";
  //             var addtechDef = "";
  //             var scriptrunkDef = "";
  //             var operatorDef = "";
  //             var tech = "";
  //             var techDef = "";
  //             var idgrupo_rota = "";
  //             var idgrupo_rotaDef = "";
  //             var idgrupo_transb = "";
  //             var idgrupo_transbDef = "";
  //             var chamado = document.getElementById("chamado").value;
  //             var retorno = 0;
  //             var checkAtd = false;
  //             var tipochamada = 0;
  //             var caracterAdicional = "";
  //             var dddValidado = "";

  //             if(mediaid === 5 || mediaid === 1 || mediaid === 8){
  //                 chamado = chamado.replace(/\D/g,'');
  //             }

  //         if((permrouter[0].areacodeid!="undefined")&&(permrouter[0].areacodeid!="")) {
  //             var DDD = permrouter[0].areacodeid;
  //             var DDDPadrao = permrouter[0].areacodeid;
  //         } else{
  //             var DDD = '71';
  //             var DDDPadrao = '71';
  //         }

  //                 var calledDigitado = chamado;
  //                 var valorfixo = [1,2,3,4];
  //                 var valormovel = [5,6,7,8,9];
  //                 if(connection_platform.remove_digits || parseInt(mediaid) !== 1){
  //                     if(chamado[0] === '0' && chamado.substr(0,2)!='00' && chamado.substr(0,4)!='0800' ){
  //                         caracterAdicional = chamado.substr(0,1);
  //                         chamado = chamado.substr(1,(chamado.length - 1));

  //                     }
  //                 }

  //                 if((chamado.length === 12 || chamado.length === 13)&&chamado.substr(0,2)!='00'){
  //                     if(chamado.substr(0,2) === '55'){
  //                         chamado = chamado.substr(2,(chamado.length - 1));
  //                         calledDigitado =calledDigitado.substr(2,(calledDigitado.length - 1));
  //                     }

  //                     dddValidado = chamado.substr(2,2);

  //                     if(!connection_platform.remove_digits && parseInt(mediaid) === 1 && chamado.startsWith('0')){
  //                         dddValidado = chamado.substr(1,2);
  //                     }

  //                     if(parseInt(dddValidado)!=parseInt(DDDPadrao)){
  //                         if(valorfixo.indexOf(parseInt(chamado[4]))> -1){
  //                         if(mediaid ==1)
  //                             tipochamada = 3;
  //                             else if(mediaid ===5)
  //                             tipochamada =17;
  //                             else if(mediaid ===8)
  //                             tipochamada =19;
  //                             else if(mediaid ===4)
  //                             tipochamada =18;
  //                             else if(mediaid ===6)
  //                             tipochamada =20;
  //                             else if(mediaid ===9)
  //                             tipochamada =21;
  //                             else if(mediaid ===10)
  //                             tipochamada =23;
  //                             else if(mediaid ===3)
  //                             tipochamada =22;
  //                             else if(mediaid ===2)
  //                              tipochamada =24;
  //                              else if (mediaid === 11) tipochamada = 25;
  //                         }else if(valormovel.indexOf(parseInt(chamado[4]))> -1){
  //                             if(mediaid ==1)
  //                                 tipochamada = 4;
  //                             else if(mediaid ==5)
  //                                 tipochamada =17;
  //                             else if(mediaid ==8)
  //                                 tipochamada =19;
  //                             else if(mediaid ===4)
  //                                 tipochamada =18;
  //                             else if(mediaid ===6)
  //                                 tipochamada =20;
  //                             else if(mediaid ===9)
  //                                 tipochamada =21;
  //                             else if(mediaid ===10)
  //                                 tipochamada =23;
  //                             else if(mediaid ===3)
  //                                 tipochamada =22;
  //                             else if(mediaid ===12)
  //                                 tipochamada =13;
  //                             else if(mediaid ===2)
  //                                 tipochamada =24;
  //                                 else if (mediaid === 11) tipochamada = 25;
  //                            }
  //                     }else if(parseInt(dddValidado)==parseInt(DDDPadrao)){
  //                         if(valorfixo.indexOf(parseInt(chamado[4]))> -1){
  //                             if(mediaid ==1)
  //                                 tipochamada = 1;
  //                             else if(mediaid ==5)
  //                                 tipochamada =17;
  //                             else if(mediaid ==8)
  //                                 tipochamada =19;
  //                             else if(mediaid ===4)
  //                                 tipochamada =18;
  //                             else if(mediaid ===6)
  //                                 tipochamada =20;
  //                             else if(mediaid ===9)
  //                                 tipochamada =21;
  //                             else if(mediaid ===10)
  //                                 tipochamada =23;
  //                             else if(mediaid ===3)
  //                                 tipochamada =22;
  //                             else if(mediaid ===2)
  //                                 tipochamada =24;
  //                                 else if (mediaid === 11) tipochamada = 25;
  //                            }else if(valormovel.indexOf(parseInt(chamado[4]))> -1){
  //                             if(mediaid ==1)
  //                                 tipochamada = 2;
  //                             else if(mediaid ==5)
  //                                 tipochamada =17;
  //                             else if(mediaid ==8)
  //                                 tipochamada =19;
  //                             else if(mediaid ===4)
  //                                 tipochamada =18;
  //                             else if(mediaid ===6)
  //                                 tipochamada =20;
  //                             else if(mediaid ===9)
  //                                 tipochamada =21;
  //                             else if(mediaid ===10)
  //                                 tipochamada =23;
  //                             else if(mediaid ===3)
  //                                 tipochamada =22;
  //                             else if(mediaid ===12)
  //                                 tipochamada =13;
  //                             else if(mediaid ===2)
  //                                 tipochamada =24;
  //                                 else if (mediaid === 11) tipochamada = 25;
  //                            }
  //                     }
  //                 }

  //                 if((chamado.length === 10 || chamado.length === 11)&&(chamado.substr(0,4)!='0800')&&(chamado.substr(0,2)!='00')){

  //                      if(!connection_platform.remove_digits && chamado[0] === '0'){
  //                         DDD = chamado.substr(1,2);
  //                         chamado = chamado.substr(3,(chamado.length - 1));
  //                      }else{
  //                         DDD = chamado.substr(0,2);
  //                         chamado = chamado.substr(2,(chamado.length - 1));
  //                      }

  //                     if((chamado.length === 8)&&(parseInt(chamado.substr(0,1))>=6)){
  //                         if(parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9){
  //                             chamado = '9'+chamado;
  //                         }
  //                     }

  //                     if(parseInt(parseInt(DDD))!=parseInt(DDDPadrao)&&chamado.substr(0,2)!='00'){

  //                         if(valorfixo.indexOf(parseInt(chamado[0]))> -1){
  //                             if(mediaid ==1)
  //                                 tipochamada = 3;
  //                             else if(mediaid ==5)
  //                                 tipochamada =17;
  //                             else if(mediaid ==8)
  //                                 tipochamada =19;
  //                             else if(mediaid ===4)
  //                                 tipochamada =18;
  //                             else if(mediaid ===6)
  //                                 tipochamada =20;
  //                             else if(mediaid ===9)
  //                                 tipochamada =21;
  //                             else if(mediaid ===10)
  //                                 tipochamada =23;
  //                             else if(mediaid ===3)
  //                                 tipochamada =22;
  //                             else if(mediaid ===2)
  //                                 tipochamada =24;
  //                                 else if (mediaid === 11) tipochamada = 25;
  //                            }else if(valormovel.indexOf(parseInt(chamado[0]))> -1){
  //                             if(mediaid ==1)
  //                                 tipochamada = 4;
  //                             else if(mediaid ==5)
  //                                 tipochamada =17;
  //                             else if(mediaid ==8)
  //                                 tipochamada =19;
  //                             else if(mediaid ===4)
  //                                 tipochamada =18;
  //                             else if(mediaid ===6)
  //                                 tipochamada =20;
  //                             else if(mediaid ===12)
  //                                 tipochamada =13;
  //                             else if(mediaid ===9)
  //                                 tipochamada =21;
  //                             else if(mediaid ===10)
  //                                 tipochamada =23;
  //                             else if(mediaid ===3)
  //                                 tipochamada =22;
  //                             else if(mediaid ===2)
  //                                 tipochamada =24;
  //                                 else if (mediaid === 11) tipochamada = 25;
  //                            }
  //                     }else if(parseInt(DDD)==parseInt(DDDPadrao)){
  //                         if(valorfixo.indexOf(parseInt(chamado[0]))> -1){
  //                             if(mediaid ==1)
  //                                 tipochamada = 1;
  //                             else if(mediaid ==5)
  //                                 tipochamada =17;
  //                             else if(mediaid ==8)
  //                                 tipochamada =19;
  //                             else if(mediaid ===4)
  //                                 tipochamada =18;
  //                             else if(mediaid ===6)
  //                                 tipochamada =20;
  //                             else if(mediaid ===12)
  //                                 tipochamada =13;
  //                             else if(mediaid ===9)
  //                                 tipochamada =21;
  //                             else if(mediaid ===10)
  //                                 tipochamada =23;
  //                             else if(mediaid ===3)
  //                                 tipochamada =22;
  //                             else if(mediaid ===2)
  //                                 tipochamada =24;
  //                                 else if (mediaid === 11) tipochamada = 25;
  //                            }else if(valormovel.indexOf(parseInt(chamado[0]))> -1){
  //                             if(mediaid ==1)
  //                                 tipochamada = 2;
  //                             else if(mediaid ==5)
  //                                 tipochamada =17;
  //                             else if(mediaid ==8)
  //                                 tipochamada =19;
  //                             else if(mediaid ===4)
  //                                 tipochamada =18;
  //                             else if(mediaid ===6)
  //                                 tipochamada =20;
  //                             else if(mediaid ===12)
  //                                 tipochamada =13;
  //                             else if(mediaid ===9)
  //                                 tipochamada =21;
  //                             else if(mediaid ===10)
  //                                 tipochamada =23;
  //                             else if(mediaid ===3)
  //                                 tipochamada =22;
  //                             else if(mediaid ===2)
  //                                 tipochamada =24;
  //                                 else if (mediaid === 11) tipochamada = 25;
  //                            }
  //                     }
  //                     if(mediaid !==8){
  //                         chamado = DDD+chamado;
  //                         calledDigitado = DDD+calledDigitado;

  //                     }

  //                 }else if(chamado.length === 8 || chamado.length === 9){
  //                     if((chamado.length === 8)&&(parseInt(chamado.substr(0,1))>=6)){
  //                         if(parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9){
  //                             chamado = '9'+chamado;
  //                         }
  //                     }

  //                     if(valorfixo.indexOf(parseInt(chamado[0]))> -1){
  //                         if(mediaid ==1)
  //                             tipochamada = 1;
  //                         else if(mediaid ==5)
  //                             tipochamada =17;
  //                         else if(mediaid ==8)
  //                             tipochamada =19;
  //                         else if(mediaid ===4)
  //                             tipochamada =18;
  //                         else if(mediaid ===6)
  //                             tipochamada =20;
  //                         else if(mediaid ===9)
  //                             tipochamada =21;
  //                         else if(mediaid ===10)
  //                             tipochamada =23;
  //                         else if(mediaid ===12)
  //                             tipochamada =13;
  //                         else if(mediaid ===3)
  //                             tipochamada =22;
  //                         else if(mediaid ===2)
  //                              tipochamada =24;
  //                              else if (mediaid === 11) tipochamada = 25;
  //                     }else if(valormovel.indexOf(parseInt(chamado[0]))> -1){
  //                         if(mediaid ==1)
  //                             tipochamada = 2;
  //                         else if(mediaid ==5)
  //                             tipochamada =17;
  //                         else if(mediaid ==8)
  //                             tipochamada =19;
  //                         else if(mediaid ===4)
  //                             tipochamada =18;
  //                         else if(mediaid ===6)
  //                             tipochamada =20;
  //                         else if(mediaid ===12)
  //                             tipochamada =13;
  //                         else if(mediaid ===9)
  //                             tipochamada =21;
  //                         else if(mediaid ===10)
  //                             tipochamada =23;
  //                         else if(mediaid ===3)
  //                             tipochamada =22;
  //                         else if(mediaid ===2)
  //                              tipochamada =24;
  //                              else if (mediaid === 11) tipochamada = 25;
  //                     }
  //                     if(mediaid!==1 && mediaid !==8){
  //                         chamado = DDD+chamado;
  //                         calledDigitado = DDD+calledDigitado;
  //                     }

  //                 }else if(chamado.substr(0,4)=='0800'){
  //                 // chamado = '0'+chamado;
  //                     tipochamada = 8;
  //                 }else if(chamado.substr(0,2)=='00'){
  //                     if(mediaid ==1)
  //                         tipochamada = 5;
  //                     else if(mediaid ==5)
  //                         tipochamada =17;
  //                     else if(mediaid ==8)
  //                         tipochamada =19;
  //                     else if(mediaid ===4)
  //                         tipochamada =18;
  //                     else if(mediaid ===12)
  //                         tipochamada =13;
  //                     else if(mediaid ===6)
  //                         tipochamada =20;
  //                     else if(mediaid ===9)
  //                         tipochamada =21;
  //                     else if(mediaid ===10)
  //                         tipochamada =23;
  //                     else if(mediaid ===3)
  //                         tipochamada =22;
  //                     else if(mediaid ===2)
  //                         tipochamada =24;
  //                         else if (mediaid === 11) tipochamada = 25;
  //            }else{
  //                     permrouter.map(result =>{
  //                         if(result.calltypeid==11){

  //                             if((parseInt(chamado)>=parseInt(result.partialnumber))&&(parseInt(chamado)<=parseInt(result.partialnumber_end))){
  //                                 tipochamada = 11;
  //                             }
  //                         }else if(result.calltypeid==6){
  //                             if(parseInt(chamado)===parseInt(result.partialnumber)){
  //                                 tipochamada = 6;
  //                             }
  //                         }

  //                     });
  //                 }

  //                 AtdSimult.map(atend => {
  //                 if(String(atend.telefone) === String(chamado) && parseInt(mediaid)===parseInt(atend.idmidia))
  //                     checkAtd = true;
  //                 })

  //                 if(mediaid ===4)
  //                     tipochamada =18;
  //                 else if(mediaid ===6)
  //                     tipochamada =20;
  //                 else if(mediaid ===9)
  //                     tipochamada =21;
  //                 else if(mediaid ===10)
  //                     tipochamada =23;
  //                 else if(mediaid ===12)
  //                     tipochamada =13;
  //                 else if(mediaid ===3)
  //                     tipochamada =22;
  //                 else if(mediaid ===2)
  //                     tipochamada =24;
  //                 else if (mediaid === 11) tipochamada = 25;

  //             if(checkAtd===false){
  //                 if(chamado!==""){

  //                     if (!isNaN( chamado ) ) {
  //                         this.setState({senhaincorreta: 'none'})

  //                         permrouter.map(result =>{
  //                             if(parseInt(result.idmidia)===parseInt(mediaid)){

  //                                 if(parseInt(tipochamada) == result.calltypeid){

  //                                         if(parseInt(tipochamada)==1){
  //                                             if(((parseInt(chamado)>=parseInt(result.areacode+result.partialnumber))&&(chamado<=parseInt(result.areacode+result.partialnumber_end)))||(parseInt(chamado)==parseInt(result.areacode+result.partialnumber))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             } else if(((parseInt(chamado.substr(parseInt(chamado.length)-8,4))>=parseInt(result.partialnumber))&&(chamado.substr(parseInt(chamado.length)-8,4)<=parseInt(result.partialnumber_end)))||(parseInt(chamado.substr(parseInt(chamado.length)-8,4))==parseInt(result.partialnumber))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             } else if(result.operator!==null && result.operator !="" && result.areacode === parseInt(chamado.substr(parseInt(chamado.length)-10,2))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             }else if(rotaencontrada==false){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             }

  //                                         }else if(parseInt(tipochamada)==2){
  //                                             if(((parseInt(chamado)>=parseInt(result.areacode+result.partialnumber))&&(chamado<=parseInt(result.areacode+result.partialnumber_end)))||(parseInt(chamado)==parseInt(result.areacode+result.partialnumber))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             } else if(((parseInt(chamado.substr(parseInt(chamado.length)-8,4))>=parseInt(result.partialnumber))&&(chamado.substr(parseInt(chamado.length)-8,4)<=parseInt(result.partialnumber_end)))||(parseInt(chamado.substr(parseInt(chamado.length)-8,4))==parseInt(result.partialnumber))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             } else if(result.operator!==null && result.operator !="" && result.areacode === parseInt(chamado.substr(parseInt(chamado.length)-11,2))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             }else if(rotaencontrada==false){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             }
  //                                         }else if(parseInt(tipochamada)==3){
  //                                             if(((parseInt(chamado)>=parseInt(result.areacode+result.partialnumber))&&(chamado<=parseInt(result.areacode+result.partialnumber_end)))||(parseInt(chamado)==parseInt(result.areacode+result.partialnumber))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             } else if(((parseInt(chamado.substr(parseInt(chamado.length)-8,4))>=parseInt(result.partialnumber))&&(chamado.substr(parseInt(chamado.length)-8,4)<=parseInt(result.partialnumber_end)))||(parseInt(chamado.substr(parseInt(chamado.length)-8,4))==parseInt(result.partialnumber))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             }  else if(parseInt(chamado.substr(parseInt(chamado.length)-10,2))==parseInt(result.areacode)){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             }else if(rotaencontrada==false){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             }
  //                                         }else if(parseInt(tipochamada)==4){
  //                                             if(((parseInt(chamado)>=parseInt(result.areacode+result.partialnumber))&&(chamado<=parseInt(result.areacode+result.partialnumber_end)))||(parseInt(chamado)==parseInt(result.areacode+result.partialnumber))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             } else if(((parseInt(chamado.substr(parseInt(chamado.length)-8,4))>=parseInt(result.partialnumber))&&(chamado.substr(parseInt(chamado.length)-8,4)<=parseInt(result.partialnumber_end)))||(parseInt(chamado.substr(parseInt(chamado.length)-8,4))==parseInt(result.partialnumber))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             } else if(parseInt(chamado.substr(parseInt(chamado.length)-11,2))==parseInt(result.areacode)){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 checkRota = true;
  //                                                 existeRota = true;
  //                                             } else if(rotaencontrada==false){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             }
  //                                         }else if(parseInt(tipochamada)==5){
  //                                             if(rotaencontrada==false){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             }
  //                                         }else if(parseInt(tipochamada)==8){
  //                                             if(rotaencontrada==false){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                             }
  //                                         }else if((parseInt(tipochamada)!=5) && ((chamado.substr(0,2)=='00') &&(parseInt(result.operator)==parseInt(chamado.substr(0,2))))){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = '';
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 existeRota = true;
  //                                                 checkRota = true;
  //                                         }else if(parseInt(tipochamada)==11){
  //                                             permrouter.map(result =>{
  //                                                 if(result.calltypeid==11){
  //                                                     if((parseInt(chamado)>=parseInt(result.partialnumber))&&(parseInt(chamado)<=parseInt(result.partialnumber_end))){
  //                                                         trunk = result.idtrunk;
  //                                                         addtech = result.addtech;
  //                                                         scriptrunk = result.scripttrunk;
  //                                                         operator = '';
  //                                                         tech = result.tech;
  //                                                         idgrupo_rota = result.idgrupo_rota;
  //                                                         idgrupo_transb = result.idgrupo_transb;
  //                                                         rotaencontrada = true;
  //                                                         existeRota = true;
  //                                                         checkRota = true;
  //                                                     }
  //                                                 }

  //                                             });

  //                                         }else if(parseInt(tipochamada)==6){
  //                                             permrouter.map(result =>{
  //                                                 if(result.calltypeid==6){
  //                                                     if(parseInt(chamado)===parseInt(result.partialnumber)){
  //                                                         trunk = result.idtrunk;
  //                                                         addtech = result.addtech;
  //                                                         scriptrunk = result.scripttrunk;
  //                                                         operator = '';
  //                                                         tech = result.tech;
  //                                                         idgrupo_rota = result.idgrupo_rota;
  //                                                         idgrupo_transb = result.idgrupo_transb;
  //                                                         rotaencontrada = true;
  //                                                         existeRota = true;
  //                                                         checkRota = true;
  //                                                     }
  //                                                 }

  //                                             });

  //                                         }else{
  //                                         if(rotaencontrada==false){
  //                                                 trunk = result.idtrunk;
  //                                                 addtech = result.addtech;
  //                                                 scriptrunk = result.scripttrunk;
  //                                                 operator = result.operator;
  //                                                 tech = result.tech;
  //                                                 idgrupo_rota = result.idgrupo_rota;
  //                                                 idgrupo_transb = result.idgrupo_transb;
  //                                                 rotaencontrada = true;
  //                                                 existeRota = true;
  //                                             }
  //                                         }

  //                                 }

  //                             }

  //                         });
  //                         if(existeRota==true){
  //                             for(let i=0; i<queue.length; i++){
  //                                 var numberqueue = queue[i].caller;

  //                                 //if(chamado === numberqueue){
  //                                 if(numberqueue.search(chamado) !==-1){
  //                                     retorno = 1;
  //                                     var queueid = queue[i].queueid;
  //                                     var recvcount = queue[i].recv_count;
  //                                     var cdrid = queue[i].cdrid;
  //                                     var srvin = queue[i].serviceinid;
  //                                     var caller = queue[i].caller;
  //                                     var called = queue[i].called;
  //                                     var cbackcount = queue[i].callback_count;
  //                                     var status = queue[i].status
  //                                 }
  //                         }

  //                         if(mediaid === 5){
  //                             chamado = chamado.toString();
  //                             chamado = chamado.trim();
  //                             calledDigitado = calledDigitado.toString();
  //                             calledDigitado = calledDigitado.trim();
  //                         }else if(mediaid === 8){
  //                             chamado = chamado.toString();
  //                             chamado = chamado.trim();
  //                             calledDigitado = calledDigitado.toString();
  //                             calledDigitado = calledDigitado.trim();
  //                         }

  //                         if(mediaid==1){

  //                             if(retorno === 1){
  //                                 this.props.RequestActiveCallSocketVoz(outband,infouser,trunk,mediaid,caracterAdicional+chamado,addtech,scriptrunk,operator,true,queueid,recvcount,null,tech,idgrupo_rota,idgrupo_transb,ipcurrent,cdrid,checkRota);
  //                                 this.props.ReturningCallbackIn(queueid,true,recvcount,cdrid,mediaid,srvin,caller,called,cbackcount,status)
  //                                 this.props.ShowInfoDisplay('Clientes');
  //                             }else{
  //                                 this.props.RequestActiveCallSocketVoz(outband,infouser,trunk,mediaid,caracterAdicional+chamado,addtech,scriptrunk,operator,false,queueid,recvcount,null,tech,idgrupo_rota,idgrupo_transb,ipcurrent,cdrid,checkRota);
  //                                 this.props.ReturningCallbackIn(queueid,true,recvcount,cdrid,mediaid,srvin,caller,called,cbackcount,status);
  //                                 this.props.ShowInfoDisplay('Clientes');
  //                             }

  //                         }else{
  //                             if(retorno === 1){
  //                                 this.props.RequestActiveCall(outband,infouser,trunk,mediaid,chamado,addtech,scriptrunk,operator,true,queueid,recvcount,cbackcount,idgrupo_transb,cdrid)
  //                                 this.props.ReturningCallbackIn(queueid,true,recvcount,cdrid,mediaid,srvin,caller,called,cbackcount,status)
  //                                 this.props.ShowInfoDisplay('Clientes');
  //                             }else{
  //                                 this.props.RequestActiveCall(outband,infouser,trunk,mediaid,chamado,addtech,scriptrunk,operator,false,queueid,recvcount,cbackcount,idgrupo_transb)
  //                                 this.props.ShowInfoDisplay('Clientes');
  //                             }
  //                         }
  //                         this.props.ShowActiveCallIn('')
  //                         MicroModal.close('modal__falar-com-cliente');
  //                         this.numberToActive.value = '';
  //                         }else{
  //                             this.setState({senhaincorreta: 'block'}) ;
  //                             document.getElementById('div_alert').innerHTML='Sem rota de sa&iacute;da!';
  //                         }
  //                     }else{
  //                         this.setState({senhaincorreta: 'block'}) ;
  //                         document.getElementById('div_alert').innerHTML='Apenas n&uacute;meros!';
  //                     }
  //                 }  else{
  //                     this.setState({senhaincorreta: 'block'});
  //                     document.getElementById('div_alert').innerHTML='Informe o n&uacute;mero!';
  //                 }
  //                 this.props.InterationNotifier('Este cliente já está sendo atendido por você','call')
  //         }
  //     }
  // }

  SolicitarChamadaAtiva(
    e,
    permrouter,
    mediaid,
    outband,
    infouser,
    callStatus,
    queue,
    AtdSimult,
    ipcurrent,
    statusAgent,
  ) {
    document.getElementById("div_alert").innerHTML = "";

    if (this.props.ContactId.length !== 0) {
      localStorage.setItem(
        "current-service",
        this.props.ContactId.idatendimento,
      );
    }

    if (!statusAgent.allowCall) {
      this.props.InterationNotifier("Pausa não permite ativo", "permission");
      return true;
    }

    const chatMessage = document.getElementById("chat-message");
    if (chatMessage) chatMessage.innerText = "";

    if (!permrouter || permrouter.length === 0) return;

    let chamado = document.getElementById("chamado").value.replace(/\D/g, "");
    const rawNumber = chamado;
    let tipochamada = 0;
    let DDD = permrouter[0].areacodeid || "71";

    const valorfixo = [1, 2, 3, 4],
      valormovel = [5, 6, 7, 8, 9];
    const removeDigits =
      connection_platform.remove_digits || parseInt(mediaid) !== 1;

    if (
      removeDigits &&
      chamado.startsWith("0") &&
      !chamado.startsWith("00") &&
      !chamado.startsWith("0800")
    ) {
      chamado = chamado.substring(1);
    }

    function definirTipoChamada(mediaid, tipo) {
      const tipos = {
        fixoInterurbano: [3, 17, 19, 18, 20, 21, 23, 22, 24, 25],
        movelInterurbano: [4, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
        fixoLocal: [1, 17, 19, 18, 20, 21, 23, 22, 24, 25],
        movelLocal: [2, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
      };

      // Converte mediaid para inteiro
      const midiaConvertida = parseInt(mediaid, 10);

      // Se mediaid for 1, busca no objeto `tipos`, senão segue a lógica específica
      if (midiaConvertida === 1) {
        return tipos[tipo] ? tipos[tipo][midiaConvertida - 1] || 0 : 0;
      } else {
        const mapeamentoMidia = {
          2: 24,
          3: 22,
          4: 18,
          5: 17,
          6: 20,
          8: 19,
          9: 21,
          10: 23,
          12: 13,
          15: 26,
        };

        return mapeamentoMidia[midiaConvertida] || midiaConvertida;
      }
    }

    if (
      (chamado.length >= 10 || chamado.length === 8 || chamado.length === 9) &&
      !chamado.startsWith("00")
    ) {
      if (
        chamado.startsWith("55") &&
        (mediaid === 5 || mediaid === "5") &&
        chamado.length > 11
      )
        chamado = chamado.substr(2);
      if (chamado.length === 8 || chamado.length === 9) chamado = DDD + chamado;
    }

    let chamadoValidado = chamado.replace(/^0(?!0|800|300)/, "");
    console.log("INGENIUM_ACTVECALL_0 : ", chamado);

    let dddValidado =
      chamadoValidado.length >= 10 ? chamadoValidado.substr(0, 2) : "";

    console.log("INGENIUM_ACTVECALL_0 : ", chamadoValidado);

    if (
      chamadoValidado.length >= 10 &&
      !chamadoValidado.startsWith("00") &&
      !chamadoValidado.startsWith("0800")
    ) {
      if (valorfixo.includes(parseInt(chamadoValidado[2]))) {
        tipochamada = definirTipoChamada(
          mediaid,
          dddValidado && parseInt(dddValidado) !== parseInt(DDD)
            ? "fixoInterurbano"
            : "fixoLocal",
        );
      } else if (valormovel.includes(parseInt(chamadoValidado[2]))) {
        tipochamada = definirTipoChamada(
          mediaid,
          dddValidado && parseInt(dddValidado) !== parseInt(DDD)
            ? "movelInterurbano"
            : "movelLocal",
        );
      }
    } else if (chamadoValidado.startsWith("0800")) {
      tipochamada = 8;
    } else if (chamadoValidado.startsWith("00")) {
      tipochamada = 5;
    } else {
    }

    console.log("INGENIUM_ACTVECALL_1 : ", tipochamada);

    // function buscarRota() {
    //     let rota = null;

    //     console.log("INGENIUM_ACTVECALL_1 : ",permrouter)

    //     permrouter.forEach(result => {

    //         if (result.calltypeid === tipochamada && parseInt(result.idmidia) === parseInt(mediaid)) {
    //             rota = result;
    //         }
    //     });
    //     return rota;
    // }

    function buscarRota() {
      let rota = [];

      console.log("INGENIUM_ACTVECALL_1 : ", permrouter);

      const doisPrimeirosDigitos = chamadoValidado.substring(0, 2);

      // Só verifica `areacode` se `mediaid` for 1
      const verificarAreacode = parseInt(mediaid) === 1;
      const verificarWhatsappInternacional = parseInt(mediaid) === 5;

      // Verifica se existe pelo menos um item com areacode correspondente (somente se `mediaid` for 1)
      const existeAreaCode = verificarAreacode
        ? permrouter.some(
            (result) =>
              result.areacode &&
              String(result.areacode).startsWith(doisPrimeirosDigitos),
          )
        : false;

      permrouter.forEach((result) => {
        if (
          result.calltypeid === tipochamada &&
          parseInt(result.idmidia) === parseInt(mediaid) &&
          (!verificarAreacode ||
            !existeAreaCode ||
            (result.areacode &&
              String(result.areacode).startsWith(doisPrimeirosDigitos)))
        ) {
          rota.push(result);
        }
        if (result.calltypeid === 11 && rota.length === 0) {
          if (
            parseInt(chamado) >= parseInt(result.partialnumber) &&
            parseInt(chamado) <= parseInt(result.partialnumber_end)
          ) {
            rota.push(result);
          }
        } else if (result.calltypeid === 6 && rota.length === 0) {
          if (parseInt(chamado) === parseInt(result.partialnumber)) {
            rota.push(result);
          }
        } else if (
          tipochamada === 5 &&
          mediaid === 5 &&
          result.calltypeid === 17
        ) {
          rota.push(result);
          chamado = chamado.replace(/^00/, "");
        }
      });

      console.log("INGENIUM_ACTVECALL_1222222 : ", rota);

      if (rota && rota.length > 1) {
        let isExistOther = false;
        rota.forEach((result) => {
          const lastEight = String(chamado).slice(-8);
          if (
            parseInt(lastEight) >= parseInt(result.partialnumber) &&
            parseInt(lastEight) <= parseInt(result.partialnumber_end)
          ) {
            rota = result;
            isExistOther = true;
          }
        });
        if (!isExistOther) {
          rota = rota.filter((temp) => temp.isdefault === "t");
          rota = rota.length !== 0 ? rota[0] : [];
        }
      } else if (rota.length === 1) {
        rota = rota[0];
      }

      return rota;
    }

    const rotaEncontrada = buscarRota();

    console.log("INGENIUMACTIVECALL", rotaEncontrada);

    if (rotaEncontrada.length === 0) {
      this.setState({ senhaincorreta: "block" });
      document.getElementById("div_alert").innerHTML = "Sem rota de saída!";
      return;
    }

    let retorno = 0;
    // let queueData = queue.find(q => q.caller.includes(chamado));
    let queueData = queue.find(
      (q) => q.caller.includes(chamado) && q.mediaid === mediaid,
    );
    if (queueData) {
      retorno = 1;
    }

    let queueid = queueData && queueData.queueid ? queueData.queueid : null;
    let recvcount =
      queueData && queueData.recvcount ? queueData.recvcount : null;
    let cdrid = queueData && queueData.cdrid ? queueData.cdrid : null;
    let srvin =
      queueData && queueData.serviceinid ? queueData.serviceinid : null;
    let caller = queueData && queueData.caller ? queueData.caller : null;
    let called = queueData && queueData.called ? queueData.called : null;
    let cbackcount =
      queueData && queueData.callback_count ? queueData.callback_count : null;
    let queueStatus =
      queueData && queueData.queueStatus ? queueData.queueStatus : null;
    let tech = rotaEncontrada.tech;
    let idgrupo_rota = rotaEncontrada.idgrupo_rota;
    let idgrupo_transb = rotaEncontrada.idgrupo_transb;
    let checkRota = true;

    if (mediaid === 5 || mediaid === 8) {
      chamado = chamado.trim();
    }

    if (mediaid === 1) {
      if (retorno === 1) {
        this.props.RequestActiveCallSocketVoz(
          outband,
          infouser,
          rotaEncontrada.idtrunk,
          mediaid,
          chamado,
          rotaEncontrada.addtech,
          rotaEncontrada.scripttrunk,
          rotaEncontrada.operator,
          true,
          queueid,
          recvcount,
          null,
          tech,
          idgrupo_rota,
          idgrupo_transb,
          ipcurrent,
          cdrid,
          checkRota,
        );
        this.props.ReturningCallbackIn(
          queueid,
          true,
          recvcount,
          cdrid,
          mediaid,
          srvin,
          caller,
          called,
          cbackcount,
          queueStatus,
        );
      } else {
        this.props.RequestActiveCallSocketVoz(
          outband,
          infouser,
          rotaEncontrada.idtrunk,
          mediaid,
          chamado,
          rotaEncontrada.addtech,
          rotaEncontrada.scripttrunk,
          rotaEncontrada.operator,
          false,
          queueid,
          recvcount,
          null,
          tech,
          idgrupo_rota,
          idgrupo_transb,
          ipcurrent,
          cdrid,
          checkRota,
        );
        this.props.ReturningCallbackIn(
          queueid,
          true,
          recvcount,
          cdrid,
          mediaid,
          srvin,
          caller,
          called,
          cbackcount,
          queueStatus,
        );
      }
    } else {
      if (retorno === 1) {
        this.props.RequestActiveCall(
          outband,
          infouser,
          rotaEncontrada.idtrunk,
          mediaid,
          chamado,
          rotaEncontrada.addtech,
          rotaEncontrada.scripttrunk,
          rotaEncontrada.operator,
          true,
          queueid,
          recvcount,
          cbackcount,
          idgrupo_transb,
          cdrid,
          rawNumber,
        );
        this.props.ReturningCallbackIn(
          queueid,
          true,
          recvcount,
          cdrid,
          mediaid,
          srvin,
          caller,
          called,
          cbackcount,
          queueStatus,
        );
      } else {
        this.props.RequestActiveCall(
          outband,
          infouser,
          rotaEncontrada.idtrunk,
          mediaid,
          chamado,
          rotaEncontrada.addtech,
          rotaEncontrada.scripttrunk,
          rotaEncontrada.operator,
          false,
          queueid,
          recvcount,
          cbackcount,
          idgrupo_transb,
          undefined,
          rawNumber,
        );
      }
    }

    this.props.ShowInfoDisplay("Clientes");
    this.props.ShowActiveCallIn("");
    MicroModal.close("modal__falar-com-cliente");
    this.numberToActive.value = "";
  }

  startInteractionMail() {
    document.getElementById("div_alert").innerHTML = "";
    let emailValid = "";
    if (document.getElementById("chamado").value) {
      localStorage.setItem(
        "email-recipient-active",
        document.getElementById("chamado").value,
      );

      if (validarEmail(document.getElementById("chamado").value))
        emailValid = document.getElementById("chamado").value;
    }
    if (emailValid) {
      this.props.InitialInteractionMail(emailValid);
      this.props.ShowInfoDisplay("Clientes");
      this.props.ShowActiveCallIn("");
      MicroModal.close("modal__falar-com-cliente");
      this.numberToActive.value = "";
    } else {
      this.setState({ senhaincorreta: "block" });
      document.getElementById("div_alert").innerHTML =
        "Email errado ou inválido!";
    }
  }

  render() {
    const {
      PermissionRouter,
      OutBandService,
      InfoUsers,
      StatusAgent,
      listCallQueue,
      ShowActiveCall,
      AtdSimult,
      IPCurrent,
    } = this.props;

    if (ShowActiveCall.showactivecall === "active") {
      this.DisplayActiveIn();
    }

    var voz = false;
    var zap = false;
    var telegram = false;
    var facebook = false;
    var instagram = false;
    var email = false;
    var twiter = false;
    var linkedin = false;
    var webchat = false;
    var sms = false;

    if (InfoUsers.user_midias) {
      for (var i = 0; i < InfoUsers.user_midias.length; i++) {
        if (InfoUsers.user_midias[i] === 1) voz = true;

        if (InfoUsers.user_midias[i] === 3) email = true;

        if (InfoUsers.user_midias[i] === 4) facebook = true;

        if (InfoUsers.user_midias[i] === 5) zap = true;

        if (InfoUsers.user_midias[i] === 6) instagram = true;

        if (InfoUsers.user_midias[i] === 8) telegram = true;

        if (InfoUsers.user_midias[i] === 9) twiter = true;

        if (InfoUsers.user_midias[i] === 10) linkedin = true;

        if (InfoUsers.user_midias[i] === 2) webchat = true;

        if (InfoUsers.user_midias[i] === 12) sms = true;
      }
    }

    return (
      <div
        className="modal micromodal-slide"
        id="modal__falar-com-cliente"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1" data-micromodal-close>
          <div
            style={{ width: "600px" }}
            className="modal__container modal__container--overflow-show new-active-call-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__falar-com-cliente__title"
          >
            <header className="modal__header modal__header-new">
              <h2 className="modal__title" id="modal__falar-com-cliente__title">
                Comece a conversa!
              </h2>
              {/* <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button> */}
              <button
                className="modal__close modal__close-new"
                aria-label="Close modal"
                data-micromodal-close
              >
                <CLOSEICON />
              </button>
            </header>
            <main
              className="modal__content modal__content-new"
              id="modal__falar-com-cliente__content"
            >
              <div className="fcc__panel">
                {/* <p className="fcc__description">
                  Digite no campo abaixo o nome ou número de telefone do cliente
                  com quem deseja falar:
                </p> */}
                {!InfoUsers.enablecallvoz && voz && (
                  <CardInformation
                    type="info"
                    className="fcc__panel__card-information-container"
                  >
                    <div className="fcc__panel__card-information">
                      <INFOCIRCLE />
                      <div className="fcc__panel__card-information__content">
                        <h2>Aguarde um momento!</h2>
                        <p>
                          Estamos conectando no servidor de voz. Isso pode levar
                          alguns instantes.
                        </p>
                      </div>
                    </div>
                  </CardInformation>
                )}
                <div className="fcc__form fcc__form-new">
                  {/* <i className="fcc__search-icon material-icons">search</i> */}
                  {/* <i className="fcc__close-icon material-icons">close</i> */}
                  <div className="new-active-call__midias">
                    <h2 className="new-active-call__midias__title">
                      Digite o número ou nome do cliente com quem deseja falar
                    </h2>
                    <input
                      type="text"
                      required
                      ref={(input) => (this.numberToActive = input)}
                      onChange={(e) => {
                        this.setState({ numeroDoCliente: e.target.value });
                      }}
                      className="fcc__search-input fcc__search-input-new"
                      name="chamado"
                      id="chamado"
                    />
                    <div
                      style={{
                        display: this.state.senhaincorreta,
                        color: "red",
                      }}
                      className="invalid-feedback"
                      id="div_alert"
                    ></div>
                  </div>
                  {/* <span className="fcc__text">Falar por:</span> */}
                  <div className="new-active-call__midias">
                    <h2 className="new-active-call__midias__title">
                      Selecione um canal para iniciar a conversa
                    </h2>
                    <div className="fcc__group-btn ">
                      {/* VOZ */}
                      <button
                        className={
                          InfoUsers.enablecallvoz && voz
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={InfoUsers.enablecallvoz && voz ? false : true}
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           1,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          key={this.state.numeroDoCliente}
                          midiaId={1}
                          numeroDoCliente={
                            document &&
                            document.getElementById("chamado") &&
                            document.getElementById("chamado").value
                              ? document.getElementById("chamado").value
                              : ""
                            //this.state.numeroDoCliente
                          }
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              1,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                      {/* WHATSAPP */}
                      <button
                        className={
                          InfoUsers.enablecall && zap
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={InfoUsers.enablecall && zap ? false : true}
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           5,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={5}
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              5,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                      {/* FACEBOOK */}
                      <button
                        className={
                          InfoUsers.enablecall && facebook
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={
                          InfoUsers.enablecall && facebook ? false : true
                        }
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           4,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={4}
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              4,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                      {/* EMAIL */}
                      <button
                        className={
                          InfoUsers.enablecall && email
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={InfoUsers.enablecall && email ? false : true}
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) => this.startInteractionMail(event)
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={3}
                          onChooseRoute={(event) => {
                            if (!InfoUsers.enablecall) return;
                            this.startInteractionMail(event);
                          }}
                        />
                      </button>
                      {/* TELEGRAM */}
                      <button
                        className={
                          InfoUsers.enablecall && telegram
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={
                          InfoUsers.enablecall && telegram ? false : true
                        }
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           8,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={8}
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              8,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                      {/* INSTAGRAM */}
                      <button
                        className={
                          InfoUsers.enablecall && instagram
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={
                          InfoUsers.enablecall && instagram ? false : true
                        }
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           6,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={6}
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              6,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                      {/* TWITER */}
                      <button
                        className={
                          InfoUsers.enablecall && twiter
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={InfoUsers.enablecall && twiter ? false : true}
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           9,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={9}
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              9,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                      {/* LINKEDIN */}
                      <button
                        className={
                          InfoUsers.enablecall && linkedin
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={
                          InfoUsers.enablecall && linkedin ? false : true
                        }
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           10,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={10}
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              10,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                      {/* WEBCHAT */}
                      <button
                        className={
                          InfoUsers.enablecall && webchat
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={
                          InfoUsers.enablecall && webchat ? false : true
                        }
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           2,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={2}
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              2,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                      {/* SMS */}
                      <button
                        className={
                          InfoUsers.enablecall && sms
                            ? "fcc__channel-btn"
                            : "fcc__channel-btn disabled"
                        }
                        disabled={
                          InfoUsers.enablecall && webchat ? false : true
                        }
                        // onClick={
                        //   InfoUsers.enablecall
                        //     ? (event) =>
                        //         this.SolicitarChamadaAtiva(
                        //           event,
                        //           PermissionRouter,
                        //           12,
                        //           OutBandService,
                        //           InfoUsers,
                        //           StatusAgent.status,
                        //           listCallQueue,
                        //           AtdSimult,
                        //           IPCurrent,
                        //           StatusAgent
                        //         )
                        //     : () => {}
                        // }
                      >
                        <SelectRouteActiveCall
                          midiaId={12}
                          onChooseRoute={(event, selectedRoute) => {
                            if (!InfoUsers.enablecall) return;
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              12,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent,
                            );
                          }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
                {/* <div
                  style={{ display: this.state.senhaincorreta, color: "red" }}
                  className="invalid-feedback"
                  id="div_alert"
                ></div> */}
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Activecall);
